import { Box, Flex, Spacer } from '@chakra-ui/react';
import useAppTheme from 'hooks/shared/useAppTheme';
import { Color } from 'presentation/theme/colorScheme';
import { FC, useMemo } from 'react';
import OrderBookChartItem from './OrderBookChartItem';

const parseDataToPoints = (
  items: OrderBookItem[],
  reverse: boolean = false
): OrderBookChartPoint[] => {
  let index = reverse ? items.length - 1 : 0;
  let value = 0;
  const points = items.map((item) => {
    const point: OrderBookChartPoint = {
      index,
      value,
    };
    value += item.count;
    if (reverse) {
      index--;
    } else {
      index++;
    }

    return point;
  });

  if (reverse) {
    return points.reverse();
  } else {
    return points;
  }
};

const getMaxCountForBoth = (
  buyPoints: OrderBookChartPoint[],
  sellPoints: OrderBookChartPoint[]
): number => {
  const maxBuy = buyPoints.length > 0 ? buyPoints[0].value : 0;
  const maxSell =
    sellPoints.length > 0 ? sellPoints[sellPoints.length - 1].value : 0;

  return Math.max(maxBuy, maxSell);
};

interface Props {
  data: OrderBook;
}

const OrderBookCharts: FC<Props> = ({ data }) => {
  const buyPoints = useMemo<OrderBookChartPoint[]>(
    () => parseDataToPoints(data.buy, true),
    []
  );
  const sellPoints = useMemo<OrderBookChartPoint[]>(
    () => parseDataToPoints(data.sell),
    []
  );
  const maxCount = getMaxCountForBoth(buyPoints, sellPoints);
  const theme = useAppTheme();

  return (
    <Flex justifyContent="space-between">
      {data.buy.length > 1 && (
        <Box flex={data.buy.length}>
          <OrderBookChartItem
            points={buyPoints}
            color={theme.colors[Color.Profit]}
            chartId="orderBookBuyChart"
            maxCount={maxCount}
          />
        </Box>
      )}
      {data.buy.length === 1 && (
        <Box w="3px" h="300px" bgColor={theme.colors[Color.Profit]} />
      )}
      <Spacer w="40px" />
      {data.sell.length > 1 && (
        <Box flex={data.sell.length}>
          <OrderBookChartItem
            points={sellPoints}
            color={theme.colors[Color.Loss]}
            chartId="orderBookSellChart"
            maxCount={maxCount}
          />
        </Box>
      )}
      {data.sell.length === 1 && (
        <Box w="3px" h="300px" bgColor={theme.colors[Color.Loss]} />
      )}
    </Flex>
  );
};

export default OrderBookCharts;
